export function isIE() {
    return Boolean(document.documentMode);
}
